/**
 * The tab whose path is the LONGEST prefix of the current path. First-match let
 * "Overview" (/analytics) claim every /analytics/* page, so sub-pages never lit
 * their own tab.
 */
export default function pickActiveTab(tabs, fullPath) {
  let best = null;
  for (const t of tabs || []) {
    if (!t?.path) continue;
    if (fullPath === t.path || fullPath.startsWith(`${t.path}/`)) {
      if (!best || t.path.length > best.path.length) best = t;
    }
  }
  return best;
}
